import React from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#001226] text-white border-t border-white/10 pt-16 md:pt-24 pb-12"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-5">
            <img
              src="/logo.png"
              alt="Adjugé-Vendu"
              className="h-14 w-auto brightness-0 invert"
              draggable={false}
            />
            <p className="mt-6 text-zinc-300 font-light leading-relaxed max-w-md">
              Maison horlogère indépendante. Sélection rigoureuse, expertise
              certifiée et estimation gratuite — au cœur de la tradition suisse,
              à Lausanne.
            </p>
            <div className="mt-8 flex gap-4">
              <a href="#" aria-label="Facebook" data-testid="social-facebook" className="w-10 h-10 border border-white/20 hover:border-accent hover:text-accent flex items-center justify-center text-white/70 transition-colors">
                <Facebook size={16} />
              </a>
              <a href="#" aria-label="Instagram" data-testid="social-instagram" className="w-10 h-10 border border-white/20 hover:border-accent hover:text-accent flex items-center justify-center text-white/70 transition-colors">
                <Instagram size={16} />
              </a>
              <a href="#" aria-label="YouTube" data-testid="social-youtube" className="w-10 h-10 border border-white/20 hover:border-accent hover:text-accent flex items-center justify-center text-white/70 transition-colors">
                <Youtube size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-accent mb-6">Navigation</p>
            <ul className="space-y-3 text-sm text-zinc-200 font-light">
              <li><a href="#neuves" className="hover:text-accent">Montres Neuves</a></li>
              <li><a href="#occasion" className="hover:text-accent">Montres d'Occasion</a></li>
              <li><a href="#reparation" className="hover:text-accent">Réparation</a></li>
              <li><a href="#or-bijoux" className="hover:text-accent">Achat Or & Bijoux</a></li>
              <li><a href="#vente" className="hover:text-accent">Vente & Estimation</a></li>
              <li><a href="#apropos" className="hover:text-accent">À propos</a></li>
              <li><a href="#contact" className="hover:text-accent">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.3em] text-accent mb-6">Boutique</p>
            <address className="not-italic text-sm text-zinc-200 font-light leading-relaxed space-y-2">
              <p>Avenue de Cour 82<br />1007 Lausanne, Suisse</p>
              <p>
                <a href="tel:+41788073799" className="hover:text-accent">078 807 37 99</a><br />
                <a href="tel:+41216162123" className="hover:text-accent">021 616 21 23</a><br />
                <a href="mailto:info@adjuge-vendu.ch" className="hover:text-accent">info@adjuge-vendu.ch</a>
              </p>
              <p className="text-zinc-400 text-xs mt-4">Lun–Ven · 10h–16h · Samedi sur rendez-vous</p>
            </address>
          </div>
        </div>

        <div className="mt-12 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-zinc-400 pt-10 border-t border-white/10">
          <p>© {new Date().getFullYear()} Adjugé-Vendu · Lausanne, Suisse. Tous droits réservés.</p>
          <p className="tracking-[0.2em] uppercase">Made in Switzerland</p>
        </div>
      </div>
    </footer>
  );
}
